/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ListResponseGenericScimResource } from '../models/list-response-generic-scim-resource';
import { PatchRequest } from '../models/patch-request';
import { UserResource } from '../models/user-resource';


/**
 * Scim users controller
 */
@Injectable({
  providedIn: 'root',
})
export class ScimUsersV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation scimFindUserV1
   */
  static readonly ScimFindUserV1Path = '/v1/integration/scim/v2/Users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scimFindUserV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  scimFindUserV1$Response(params: {
    filter: string;
    startIndex?: number;
    count?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListResponseGenericScimResource>> {

    const rb = new RequestBuilder(this.rootUrl, ScimUsersV1Service.ScimFindUserV1Path, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.query('startIndex', params.startIndex, {});
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/scim+json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListResponseGenericScimResource>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scimFindUserV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scimFindUserV1(params: {
    filter: string;
    startIndex?: number;
    count?: number;
  },
  context?: HttpContext

): Observable<ListResponseGenericScimResource> {

    return this.scimFindUserV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListResponseGenericScimResource>) => r.body as ListResponseGenericScimResource)
    );
  }

  /**
   * Path part for operation scimCreateUserV1
   */
  static readonly ScimCreateUserV1Path = '/v1/integration/scim/v2/Users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scimCreateUserV1()` instead.
   *
   * This method sends `application/scim+json` and handles request body of type `application/scim+json`.
   */
  scimCreateUserV1$Response(params: {
    body: UserResource
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserResource>> {

    const rb = new RequestBuilder(this.rootUrl, ScimUsersV1Service.ScimCreateUserV1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/scim+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/scim+json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserResource>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scimCreateUserV1$Response()` instead.
   *
   * This method sends `application/scim+json` and handles request body of type `application/scim+json`.
   */
  scimCreateUserV1(params: {
    body: UserResource
  },
  context?: HttpContext

): Observable<UserResource> {

    return this.scimCreateUserV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserResource>) => r.body as UserResource)
    );
  }

  /**
   * Path part for operation scimGetUserV1
   */
  static readonly ScimGetUserV1Path = '/v1/integration/scim/v2/Users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scimGetUserV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  scimGetUserV1$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserResource>> {

    const rb = new RequestBuilder(this.rootUrl, ScimUsersV1Service.ScimGetUserV1Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/scim+json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserResource>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scimGetUserV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scimGetUserV1(params: {
    id: string;
  },
  context?: HttpContext

): Observable<UserResource> {

    return this.scimGetUserV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserResource>) => r.body as UserResource)
    );
  }

  /**
   * Path part for operation scimPatchUserV1
   */
  static readonly ScimPatchUserV1Path = '/v1/integration/scim/v2/Users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scimPatchUserV1()` instead.
   *
   * This method sends `application/scim+json` and handles request body of type `application/scim+json`.
   */
  scimPatchUserV1$Response(params: {
    id: string;
    body: PatchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserResource>> {

    const rb = new RequestBuilder(this.rootUrl, ScimUsersV1Service.ScimPatchUserV1Path, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/scim+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/scim+json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserResource>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scimPatchUserV1$Response()` instead.
   *
   * This method sends `application/scim+json` and handles request body of type `application/scim+json`.
   */
  scimPatchUserV1(params: {
    id: string;
    body: PatchRequest
  },
  context?: HttpContext

): Observable<UserResource> {

    return this.scimPatchUserV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserResource>) => r.body as UserResource)
    );
  }

}
